<div class="d-flex flex-wrap justify-content-center" style="gap: 20px">
    <ng-container *ngFor="let item of block; let idx = index;">
        <a *ngIf="!nodeService.verifyLinkExternal(item.link.url)" [routerLink]="navigationService.splitUrlRouterLink(item.link.url).path" [queryParams]="navigationService.splitUrlRouterLink(item.link.url).queryParams">
            <button type="button" class="btn w-100 {{setTypeButton(item.tipologia_pulsante)}} ls-label-medium-semibold text-center text-uppercase"
                [innerHTML]="prettyPrintLabel(item.label)">
            </button>
        </a>
        <a class="btn {{setTypeButton(item.tipologia_pulsante)}} ls-label-medium-semibold text-center text-uppercase"
            *ngIf="nodeService.verifyLinkExternal(item.link.url)" [href]="item.link.url" target="_blank" [innerHTML]="prettyPrintLabel(item.label)">
        </a>
    </ng-container>
</div>